exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loader #wave{-webkit-text-fill-color:transparent;-webkit-background-clip:text;text-shadow:0 0 rgba(0,0,0,.1);animation:wave 1s infinite linear,loading 5s infinite linear alternate;background-size:200px 100px;background-repeat:repeat-x;font-weight:700;font-size:46px;text-align:center;line-height:110px}@keyframes wave{0%{background-position:0 bottom}to{background-position:200px bottom}}@keyframes loading{0%{background-size:200px 70px}to{background-size:200px 120px}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./frontend/components/utility/loader/loader.styl
 ** module id = 248
 ** module chunks = 0
 **/